<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <h6>账号列表</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <!-- 头像 -->
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                头像
              </th>
              <!-- 账号ID -->
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                账号ID
              </th>
              <!-- 昵称 -->
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                昵称
              </th>
              <!-- 手机号 -->
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                登录账号
              </th>
              <!-- 上级ID -->
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                店家ID
              </th>
              <!-- 入驻时间 -->
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                入驻时间
              </th>
              <!-- 操作 -->
              <th class="text-secondary opacity-7"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(author, index) in paginatedData" :key="index">
              <!-- 头像列 -->
              <td>
                <div class="d-flex px-2 py-1">
                  <div>
                    <soft-avatar :img="author.Imgurl || author.avatar" size="sm" border-radius="lg" class="me-3" alt="avatar" />
                  </div>
                </div>
              </td>
              <!-- 账号ID -->
              <td>
                <div class="d-flex px-2 py-1">
                  <div>
                    <h6 class="mb-0 text-sm">{{ author.account_id }}</h6> <!-- 显示账号ID -->
                  </div>
                </div>
              </td>
              <!-- 昵称 -->
              <td>
                <p class="text-xs font-weight-bold mb-0">{{ author.nick_name }}</p> <!-- 显示昵称 -->
              </td>
              <!-- 手机号 -->
              <td class="align-middle text-center text-sm">
                <p class="text-xs text-secondary mb-0">{{ author.account }}</p> <!-- 显示手机号 -->
              </td>
              <!-- 上级ID -->
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">{{ author.deliver_id }}</span> <!-- 显示上级ID -->
              </td>
              <!-- 入驻时间 -->
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">{{ formattedDate(author.created_date) }}</span> <!-- 显示入驻时间 -->
              </td>
              <!-- 操作 -->
              <td class="align-middle">
                <soft-button 
                  @click="toggleMenu(index)" 
                  class="text-secondary font-weight-bold text-xs"
                  :style="{backgroundColor: menuVisibleIndex === index? '#f1f1f1':'',
                    color: menuVisibleIndex === index? '#6c757d':'white'}">
                  {{ menuVisibleIndex === index? '操作':'操作>>' }}
                </soft-button>
                <!-- 操作菜单 -->
                <div v-if="menuVisibleIndex === index" class="menu">
                  <ul>
                    <li @click="editPassword(author)" style="margin-left:-10px;">修改密码</li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination Controls -->
      <div class="d-flex justify-content-between align-items-center mt-3 px-3">
        <!-- Previous Button with more padding and margin -->
        <button class="btn btn-outline-dark" @click="changePage(currentPage - 1)" :disabled="currentPage <= 1" style="margin-right: 20px;">
          上一页
        </button>

        <!-- Page info -->
        <div class="text-center">
          第 {{ currentPage }} 页/ 总 {{ totalPages }} 页
        </div>

        <!-- Next Button with more padding and margin -->
        <button class="btn btn-outline-dark" @click="changePage(currentPage + 1)" :disabled="currentPage >= totalPages" style="margin-left: 20px;">
          下一页
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SoftAvatar from "@/components/SoftAvatar.vue";
import { getsubuserlist, setsubuserpassword } from "@/api/user.js"
import SoftButton from "@/components/SoftButton.vue"
import dayjs from "dayjs";
import md5 from 'md5'

export default {
  name: "users-table",
  data() {
    return {
      // 默认头像数组
      avatarImages: [
        require("../../../assets/img/team-2.jpg"),
        require("../../../assets/img/team-3.jpg"),
        require("../../../assets/img/team-4.jpg"),
        require("../../../assets/img/team-1.jpg")
      ],
      authors: [],
      currentPage: 1,
      itemsPerPage: 10,
      searchCriteria: "全部用户",
      searchText: "",
      menuVisibleIndex: null, // Track the index of the visible menu
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.authors.length / this.itemsPerPage);
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.authors.slice(start, end);
    }
  },
  methods: {
    changePage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;
    },

    handleSearch() {
      let params = {}
      if (this.searchCriteria !== '全部用户') {
        params[this.searchCriteria] = this.searchText
      }
      getsubuserlist(params).then(response=>{
        console.log("get user info:", response)
        if (response.code === 0 ) {
            this.authors = response.desc
            this.currentPage = 1
            this.setRandomAvatars()
        }else{
          alert(response.desc)
        }       
      }).catch(error => {
        console.log('error fetching user data:', error)
       })

    },
 // 显示或隐藏菜单
    toggleMenu(index) {
      this.menuVisibleIndex = this.menuVisibleIndex === index ? null : index; // Toggle visibility
    },
    // 修改密码
    editPassword(author) {
      const newPassword = prompt("请输入新密码：");

      if (!newPassword) {
        alert("新密码不能为空！");
        return;
      }

      if (confirm(`您确定要修改账号 ${author.account} 的密码吗？`)) {
        this.changePassword(author, newPassword);
      }
    },
    setRandomAvatars() {
      this.authors.forEach(author => {
        // 从avatarImages数组中随机选择一个头像
        const randomIndex = Math.floor(Math.random() * this.avatarImages.length);
        author.avatar = this.avatarImages[randomIndex];
      });
    },
    formattedDate(timestamp) {
      return dayjs.unix(timestamp).format('YYYY/MM/DD HH:mm:ss');
    },

    changePassword(author, newPassword) {
      // 获取用户的账户信息
      const userAccount = author.account;  // 账号使用手机号

      // 计算 MD5
      const userPass = md5(userAccount + newPassword);  // md5(pass + mobile)

          // 调用接口修改密码
          const params = {
            sub_id: author.account_id,  // 传递用户ID
            newpass: userPass,  // 传递计算后的MD5密码
          };

          setsubuserpassword(params)
            .then(response => {
              if (response.code === 0) {
                alert("密码修改成功！");
              } else {
                alert("密码修改失败：" + response.desc);
              }
            })
            .catch(error => {
              console.error("修改密码时出错：", error);
              alert("密码修改失败，请稍后再试。");
            });
    },


  },
  components: {
    SoftAvatar,
    SoftButton,
  },
  mounted() {
    this.setRandomAvatars(); // 页面加载时为每个作者设置头像
    this.searchCriteria !== '全部用户'
    this.handleSearch()
  }
};
</script>

<style scoped>
/* Add any custom styles if needed */
.d-flex {
  display: flex;
  align-items: center; /* 确保元素在垂直方向居中 */
}

.form-select, .form-control {
  vertical-align: middle; /* 确保输入框和下拉框与按钮在同一水平线 */
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center; /* 确保按钮的内容居中对齐 */
  margin-top: 12px;
}

menu {
  position: absolute;
  background-color: white;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 5px;
  z-index: 10;
  max-width: 80px;
}

.menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
  max-width: 80px;
}

.menu ul li {
  padding: 8px 16px;
  cursor: pointer;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.8rem;
  border-radius: 0.5rem;
  text-align: center;
  padding: 5px;
  margin-top: 8px;
}

.menu ul li:hover {
  background-color: #f1f1f1;
}
</style>
